<script>
export default{
    data() {
        return {
            formHandler: 'submit' + Math.floor(Math.random() * 1000000),
            formData: {},
            formError: {},
            loading: false,
            message: '',
            error: '',
            recaptcha: null,
            recaptchaId: null,
        }
    },

    props: ['initialData', 'config'],

    component: {

    },

    mixins: [],

    created() {
        this.populateFormData();
        window[this.formHandler] = this.submit;
    },

    mounted() {
        if (this.recaptchaEnable && this.recaptcha) {
            this.registerRecaptcha();
        }
    },

    computed: {
        successMessage() {
            return _.get(this.config, 'successMessage',  'Your enquiry has been received and we will be in contact shortly.')
        },

        errorMessage() {
            return _.get(this.config, 'errorMessage',   'There is something wrong with the submission, please try again.');
        },

        recaptchaEnable() {
            return _.get(this.config, 'recaptcha', true);
        },

        submitCallback() {
          return _.get(this.config, 'submitCallback', 'submit');
        }
    },

    methods: {
        submit(recaptchaToken = null) {
            if (this.loading) {
                return Promise.resolve(null);
            }

            let $form = $(this.$refs['form']);
            // $form.addClass('was-validated');

            let $btn = $(this.$refs['form-btn']);

            this.loading = true;
            let endpoint = _.get(this.config, 'ajax');
            let formData = this.getRequestData();

            // convert form data
            formData = _.chain(formData)
                .toPairs()
                .map(([key, val]) => {

                    if (_.isObject(val)) {
                        return [key, JSON.stringify(val)];
                    }

                    if (_.isArray(val)) {
                        return [key, _.join(val, ', ')];
                    }

                    if (_.isBoolean(val)) {
                        return [key, val ? 1 : 0];
                    }

                    if (_.isNil(val)) {
                        return [key, ''];
                    }

                    return [key, val];
                })
                .fromPairs()
                .value();

            if (recaptchaToken) {
                formData['g-recaptcha-response'] = recaptchaToken;
            }

            endpoint = _.trimStart(endpoint, '/');
            return this.api.uploadData(`/../${endpoint}`, {}, formData)
                .then(res => {
                    this.loading = false;
                    if (this.recaptchaEnable && this.recaptchaId != 'null') {
                        // TODO: fix issue with grecaptcha reset submits form multiple times
                        this.$nextTick(() => this.initRecaptchaButton());
                    }

                    if (_.isFunction(this.onSuccess)) {
                        this.loading = false;
                        return this.onSuccess(res);
                    }

                    this.$emit('input', res, formData);
                    this.handleFormInput(res);
                    this.$forceUpdate();
                })
                .catch(err => {
                    this.loading = false;
                    if (this.recaptchaEnable && this.recaptchaId != 'null') {
                        // TODO: fix issue with grecaptcha reset submits form multiple times
                        this.$nextTick(() => this.initRecaptchaButton());
                    }

                    if (_.isFunction(this.onError)) {
                        return this.onError(err);
                    }

                    this.$emit('error', err);
                    this.handleFormError(err);

                    this.loading = false;
                    this.$forceUpdate();
                })
        },

        registerRecaptcha() {
            return (new Promise((resolve, reject) => {
                setTimeout(function () {
                    if (typeof grecaptcha === 'undefined' || typeof grecaptcha.render ==='undefined') {
                        this.registerRecaptcha();
                    } else {
                        resolve(this.initRecaptchaButton());
                    }
                }.bind(this), 100);
            }))
        },

        initRecaptchaButton() {
            if (!_.isNil(this.recaptchaId)) {
                grecaptcha.reset(this.recaptchaId);
                return;
            }

            let grecaptchaConfig = _.get(window, '__grecaptcha_cfg') || _.get(window, '___grecaptcha_cfg');
            this.recaptchaId = _.get(grecaptchaConfig, 'count', 0);
            grecaptcha.render(this.$refs['form-btn'], {
                sitekey: this.recaptcha,
                callback: this[this.submitCallback],
            });
        },

        handleFormInput(res) {
            this.loading = false;
            this.message = this.successMessage;
            this.error = '';
            this.formError = {};
            this.populateFormData();
            // this.formData = {};

            // Send dataLayer event if exists
            if (window.dataLayer){
                let defDataLayer = {};
                // calculate dataLater if exists
                if (!_.isEmpty(this.gtmDataLayer)) {
                    Object.keys(this.gtmDataLayer).forEach((key, index) => {
                        const layerObj = this.gtmDataLayer[key];
                        if (_.has(layerObj, 'static')) {
                            defDataLayer[key] = layerObj.static;
                        }

                        if (_.has(layerObj, 'var')) {
                            defDataLayer[key] = _.get(res.attributes, layerObj.var, '');
                        }
                    });
                } else {
                    let type = _.get(res, 'attributes.type', '');
                    defDataLayer = {
                        'event': 'form_submission',
                        'enquiry_id' : res.id,
                        'type' : type
                    };
                }
                dataLayer.push(defDataLayer);
            }
        },

        handleFormError(err) {
            let res = _.get(err, 'response.data');
            let errors = _.get(res, 'errors', []);
            this.message = '';

            if (res && !_.isEmpty(errors)) {
                this.error = `${res.message}`;
                this.formError = errors;
            } else {
                this.error = this.errorMessage;
            }
        },

        getFieldError(field) {
            let fieldError = _.get(this.formError, field, null);

            if (_.isArray(fieldError)) {
                return _.get(fieldError, '0', null);
            }

            return fieldError;
        },

        populateFormData() {
            _.chain(this.config)
                .get('fields', [])
                .map(field => {
                    let value = _.get(this.initialData, field.name, field.default_value ||'');
                    this.$set(this.formData, field.name, value)
                })
                .value();
        },

        getRequestData() {
            return _.assign({},
                this.initialData,
                this.config,
                this.formData, {
                form_id: this.config.id,
            });
        },
    },
}
</script>

<style scoped>

</style>
